import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {LoadScript} from '@react-google-maps/api'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
// import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'
import AppToast from './common/AppToast'

const App = () => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''

  return (
    <LoadScript googleMapsApiKey={googleMapsApiKey} libraries={['places']}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <LayoutProvider>
          <ThemeModeProvider>
            {/* <AuthInit> */}
            <AppToast />
            <Outlet />
            <MasterInit />
            {/* </AuthInit> */}
          </ThemeModeProvider>
        </LayoutProvider>
      </Suspense>
    </LoadScript>
  )
}

export {App}
